import { Config } from "../models/config.model";
import { ConfigStateModel } from "../state/config.state";

export namespace ConfigActions {
    export class Refresh {
        static readonly type = '[API-Config] Refresh'
        constructor() {}
    }
    export class Init {
        static readonly type = '[Storage-Config] Init'
        constructor(public payload: ConfigStateModel) {}
    }
    export class Set {
        static readonly type = '[API-Config] Set'
        constructor(public payload: Config) {}
    }
}
